import {
  GET_GLOSSARY,
  GET_RIGHT_NAVIGATION,
  GET_LOGO,
  SET_CLIENT_LOADING,
  GET_CLIENT_DOCUMENTS,
  SET_CLIENT_PAGES_LOADING,
  GET_CLIENT_PAGES,
  GET_STRUCTURE,
  GET_RELATED_CONTENT,
  GET_BOOKMARKS_DOCS,
  BUY_ADDITIONAL_QUERIES,
} from './clientTypes';

import {
  getLogo,
  getClientLevelList,
  getClientRightNavigation,
  getClientStructure,
  getClientDocuments,
  getClientPages,
  getRelatedContents,
  getRelatedContentsRelationships,
  getGlossaries,
  getGlossaryRelationships,
  getDocsBookmarks,
  createAdditionalPurchase,
} from '../../services/axios';
import { UPDATE_USER } from '../User/userTypes';

export const setClientLoading = () => ({
  type: SET_CLIENT_LOADING,
});

export const setLoadingPagesAction = () => ({
  type: SET_CLIENT_PAGES_LOADING,
});

export const getStructure = () => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;

    const response = await getClientStructure(spKey);
    dispatch({
      type: GET_STRUCTURE,
      payload: response,
    });
  };
};

/**
 * Fetches a level list
 * @param {{ LIST: string, LABEL: string, ACTION: string }} level The list to be fetched (levels one through four)
 * @returns The level list according to the level param
 */
export const getClientLevel = (level) => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;

    const levelList = await getClientLevelList(level.LIST, spKey);

    dispatch({
      type: level.ACTION,
      payload: levelList,
    });
  };
};

export const getDocuments = () => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;
    const documents = await getClientDocuments(spKey);

    dispatch({
      type: GET_CLIENT_DOCUMENTS,
      payload: documents,
    });
  };
};

// using this method to get docs when user is on bookmarks
// to get superseed dococuments too
export const getWorkingDocsForBookmarks = () => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;
    const documents = await getDocsBookmarks(spKey);
    dispatch({
      type: GET_BOOKMARKS_DOCS,
      payload: documents,
    });
  };
};

export const getPages = () => {
  return async (dispatch, getState) => {
    if (getState().client.proccessesRunning < 100) {
      dispatch(setLoadingPagesAction());

      const spKey = getState().user.user.spKey;

      const pages = await getClientPages(spKey);

      dispatch({
        type: GET_CLIENT_PAGES,
        payload: pages,
      });
    }
  };
};

export const getRightNavigation = () => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;

    const response = await getClientRightNavigation(spKey);
    dispatch({
      type: GET_RIGHT_NAVIGATION,
      payload: response,
    });
  };
};

export const getClientGlossary = () => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;

    const glossaries = await getGlossaries(spKey);
    const response = await getGlossaryRelationships(glossaries, spKey);

    dispatch({
      type: GET_GLOSSARY,
      payload: response,
    });
  };
};

export const getRelatedContent = () => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;

    const contents = await getRelatedContents(spKey);
    const response = await getRelatedContentsRelationships(contents, spKey);

    dispatch({
      type: GET_RELATED_CONTENT,
      payload: response,
    });
  };
};

export const getClientLogo = () => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    const spKey = getState().user.user.spKey;

    const response = await getLogo(spKey);
    dispatch({
      type: GET_LOGO,
      payload: response,
    });
  };
};

export const CreateAdditionalQueries = (type, quantity) => {
  return async (dispatch, getState) => {
    dispatch(setClientLoading());

    let user = getState().user.user;

    const data = {
      type: type,
      quantity: quantity,
      clientId: user.userClient.id,
    };

    const response = await createAdditionalPurchase(data, user.token);
    // console.log('CreateAdditionalQueries', response);

    if (response && response.success) {
      user = {
        ...user,
        userPlan: {
          ...user.userPlan,
          restrictions: {
            ...user.userPlan.restrictions,
            queries: user.userPlan.restrictions.queries + quantity,
          },
        },
        remainingAdditionalQueries: quantity,
      };

      dispatch({
        type: UPDATE_USER,
        payload: user,
      });

      return response;
    }
  };
};

// export const getClientTheme = () => {
//   return async (dispatch) => {
//     dispatch(setClientLoading());
//     const response = await getTheme();
//     dispatch({
//       type: GET_THEME,
//       payload: response,
//     });
//   };
// };
